import React, { useState, useEffect } from "react";
import "./index.scss";
import { Description } from "./description";
import data from "../../data/dummy-data/projects.json";
import { useParams } from "react-router-dom";
import { NotFound } from "../../Views/NotFound";
import { Slider } from "../Slider";

export default function ProjectDetails(props) {
  let { id } = useParams();
  const [project, setProject] = useState(null);

  useEffect(() => {
    const [project] = data.projects.filter(p => +id === +p.id);
    setProject(project);
  }, [id]);

  if (!project) {
    return <NotFound />;
  }

  return (
    <div className="project-details">
      <div className="project-details__title">
        <h1>Proyecto: {project.title}</h1>
      </div>

      <div className="project-details__content">
        <div className="project-details__content-description">
          <Description
            description={project.description}
            responsabilities={project.responsabilities}
          />
        </div>
        <div className="project-details__content-images">
          <Slider images={project.images} />
        </div>
      </div>

      <div className="project-details__link">
        {project.githubUrl && (
          <a href={project.githubUrl} target="_blank" rel="noopener noreferrer">
            Código Fuente <i className="fa fa-github"></i>
          </a>
        )}
        {project.demoUrl && (
          <a href={project.demoUrl} target="_blank" rel="noopener noreferrer">
            Demo <i className="fa fa-level-up"></i>
          </a>
        )}
      </div>
    </div>
  );
}
